import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { SmartPaletteGeneral } from "../../class/smart-palette";
import { ComponentAdapterPageBreak } from "../../class/adapters/component-adapter-page-break";
import { AppSettings } from "../../class/general-classes/app-settings";
import { SystemRouterService } from "src/service/system-router.service";
import { ModeForBreakPage } from "../../enum/enumViewMode";
import { IonButton } from "@ionic/angular";
import { SmartComponentSpinnerComponent } from "../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../error-loading-widget/error-loading-widget.component";

@Component({
    selector: "app-widget-page-break",
    templateUrl: "./widget-page-break.component.html",
    styleUrls: ["./widget-page-break.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent]
})
export class WidgetPageBreakComponent extends WidgetParent<ComponentAdapterPageBreak> {
  private readonly _routerService = inject(SystemRouterService);

  public iconSrc: string = "";
  public description: string = "";
  public showDescription: boolean = false;

  /**
   * On click navigate to the linked environment in grid or graphic view,
   * depending on the PageBreakMode skill ("0" = grid, "1" = graphic).
   */
  public onClick(): void {
    if (!this.isSendCommandPossible) {
      return;
    }
    const targetEnv = this.componentAdapter?.IdEnvironment;
    if (!targetEnv) {
      return;
    }
    const mode = this.componentAdapter?.Mode;

    if (mode === ModeForBreakPage.GRAPHIC.toString()) {
      this._routerService.navigateToGraphicSupervisionSmartComponent(targetEnv);
    } else {
      this._routerService.navigateToSupervisionSmartComponent(targetEnv);
    }
  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    return new SmartPaletteGeneral();
  }

  protected onComponentLoad(): void { }

  protected onSmartComponentErrorLoading(): void { }

  protected onComponentDestroy(): void { }

  protected async onSmartComponentSuccessLoaded(): Promise<void | boolean> {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdapterPageBreak,
    );

    this.titleWidget = this.componentAdapter.Name;

    if (!this.titleWidget) {
      return (this._errorLoading = true);
    }

    this.description = this.componentAdapter.Description;
    const rawShow = this.componentAdapter.ShowDescription?.toLowerCase();
    this.showDescription = rawShow === "true" || rawShow === "1";

    if (this.componentAdapter.Icon) {
      this.iconSrc =
        AppSettings.URL_ICONS_REPOSITORY +
        encodeURIComponent(this.componentAdapter.Icon);
    }
  }

  protected onAddressValueChange(
    instanceGUID: string,
    address: string,
    value: string,
  ): void { }
}
